// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-2B9FA2F4-3777-4124-9B9D-5E49B0B816DF .invoice-list-factor-row > td {\n  border-bottom: 4px solid black;\n}\n", "",{"version":3,"sources":["webpack://src/Sell/logisticCostCartable/logisticCostCartable.less"],"names":[],"mappings":"AACI;EACI,8BAAA;AAAR","sourcesContent":["#V-2B9FA2F4-3777-4124-9B9D-5E49B0B816DF{\n    & .invoice-list-factor-row>td{\n        border-bottom: 4px solid black;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
